export const NAME = 'name';
export const SCOPE = 'scope';
export const GROUP_ROLE = 'groupRole';
export const REGION = 'region';
export const POINT_OF_CONTACT = 'pointOfContact';
export const EXTERNAL_USER = 'externalUser';
export const INTERNAL_USER = 'internalUser';
export const NOT_USING_CANVAS = 'notUsingCanvas';
